import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useGetCategoriesQuery } from "../../api/productTaxonomyApi";
import type { TransformedWPCategory } from "../../types/productTaxonomyApiTypes";
import type { TransformedProduct } from "../../types/productApiTypes";

interface ProductBreadcrumbsProps {
  product: TransformedProduct;
}

const ProductBreadcrumbs: React.FC<ProductBreadcrumbsProps> = ({ product }) => {
  const { t } = useTranslation("common");
  const { data: categoriesData } = useGetCategoriesQuery();
  const categoriesById = categoriesData?.categories;

  const primaryCategory = product.enrichedCategories?.[0];

  const categoryPath = useMemo((): TransformedWPCategory[] => {
    if (!primaryCategory || !categoriesById) {
      return [];
    }

    const path: TransformedWPCategory[] = [];
    let currentCategory: TransformedWPCategory | undefined =
      categoriesById[primaryCategory.id];
    let safetyCounter = 0;

    while (currentCategory && safetyCounter < 10) {
      path.unshift(currentCategory);
      if (currentCategory.parent === 0) {
        break;
      }
      currentCategory = categoriesById[currentCategory.parent];
      safetyCounter++;
    }

    return path;
  }, [primaryCategory, categoriesById]);

  const siteUrl = window.themeVariables?.siteUrl || "/";
  const shopUrl = window.themeVariables?.shopUrl || "/shop/";

  return (
    <nav aria-label="Breadcrumb" className="product-breadcrumbs">
      <a href={siteUrl}>{t("breadcrumbs.home")}</a> /{" "}
      <a href={shopUrl}>{t("breadcrumbs.shop")}</a> /
      {categoryPath.map((category) => (
        <React.Fragment key={category.id}>
          <a href={category.link}>{category.name}</a> /
        </React.Fragment>
      ))}
      <span>{product.name}</span>
    </nav>
  );
};

export default ProductBreadcrumbs;
